import { Component, OnInit } from '@angular/core';
import { CognitoServiceService } from '../../services/cognito-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit {

  hideHeader: boolean = false;
  profileContainerVisibility: boolean = false;
  heading: string;

  constructor(private cognito: CognitoServiceService, private router: Router) {
    this.router.events.subscribe((res: any) => { 
      var currentRoute: string = this.router.url;
      var hideHeaderForRoutes = ["/signup", '/login', '/vua-creation', '/forgot-password', '/confirm-password']
      this.hideHeader = false;
      for(let i=0, iLen = hideHeaderForRoutes.length; i < iLen; i++) {
        if(currentRoute == hideHeaderForRoutes[i]) {
          this.hideHeader = true;
          break;
        }
      }
    })
    this.router.events.subscribe((res) => {
      var currentRoute: string = this.router.url;
      console.log('heading',currentRoute);
      // Form heading based on current route
      if (currentRoute == '/signup') {
        this.heading = "SIGN UP";
      } else if (currentRoute == '/login') {
        this.heading = "LOGIN"
      }
    })
  }

  ngOnInit() {
  }

  /**
   * @desc To signout user from application
   */
  signout() {
    this.cognito.signout((status)=> {
      if(status) {
        this.profileOutsideClicked()
        this.router.navigate(['/login']);
      }
    });
  }

  /**
   * @description To toggle the dropdown menu.
   */
  toggleProfileContainer() {
    this.profileContainerVisibility = !this.profileContainerVisibility;
  }

  /**
   * @description If click outside of the profile picture, then simply hide the dropdown menu
   */
  profileOutsideClicked() {
    this.profileContainerVisibility = false;
  }

}
